export enum ReservationType {
  NORMAL_RESERVATION = 'NORMAL_RESERVATION',
  BLOCK_DATES = 'BLOCK_DATES'
}
